/**
 * Manipulates URL search parameters in a type-safe, functional way
 *
 * @param baseUrl - Base URL to manipulate
 * @param operations - Record of param names to values (string to set, null/undefined to delete)
 * @returns Updated URL string with pathname + search params
 *
 * @example
 * manipulateUrlSearchParams('/brands?page=2', {
 *   alphabet: 'A',    // Set alphabet=A
 *   page: null,       // Delete page param
 *   search: 'motor'   // Set search=motor
 * })
 * // Returns: '/brands?alphabet=A&search=motor'
 */
export function manipulateUrlSearchParams(
  baseUrl: string,
  operations: Record<string, string | null | undefined>
): string {
  try {
    const url = new URL(baseUrl, 'http://localhost');

    for (const [key, value] of Object.entries(operations)) {
      if (value === null || value === undefined) {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
    }

    return url.pathname + url.search;
  } catch {
    return baseUrl;
  }
}
